import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Popover } from '@blueprintjs/core';
import { css } from '@emotion/react';
import { Button } from 'react-science/ui';
export function ActionsButtonsPopover(props) {
    const { buttons, children, ...otherProps } = props;
    return (_jsx(Popover, { minimal: true, position: "auto-start", popoverClassName: "actions-buttons-popover", interactionKind: "hover", enforceFocus: false, content: _jsx("div", { style: { display: 'flex', flexDirection: 'column' }, css: css `
            button,
            a[role='button'] {
              border-radius: 50%;
              min-width: 16px;
              min-height: 16px;
              font-size: 10px;
              padding: 5px;
            }
          `, children: buttons
                .filter((button) => button?.visible !== false)
                .map(({ icon, onClick, intent, title, disabled }, index) => {
                return (_jsx(Button, { disabled: disabled, icon: icon, onClick: onClick, tooltipProps: { content: title || '', compact: true }, intent: intent }, title || index));
            }) }), ...otherProps, children: children }));
}
